module.exports = __webpack_public_path__ + "img/9791187206163.1620de78.jpg";